module.exports = __webpack_public_path__ + "img/thi_truong.23858e61.jpg";